export const load = () => ({
	h1: 'Quiet Comfort Guarantee',
	showTitle: false,
	noindex: true,
});
